module.exports = __webpack_public_path__ + "media/images/leadership_characteristics/bg-6-5bc406bb4e1ff83bc1df5068cb8515ac.png";